var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStudentApprovementCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_259_2251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 0C2.91017 0 0 2.91017 0 6.5C0 10.09 2.91017 13 6.5 13C10.09 13 13 10.09 13 6.5C13 2.91017 10.09 0 6.5 0ZM6.5 12.2003C3.36395 12.2003 0.8125 9.63605 0.8125 6.49997C0.8125 3.36393 3.36395 0.812475 6.5 0.812475C9.63605 0.812475 12.1875 3.36394 12.1875 6.49997C12.1875 9.63601 9.63605 12.2003 6.5 12.2003ZM9.09411 4.12161L5.28042 7.95925L3.563 6.24183C3.40436 6.08319 3.14721 6.08319 2.98836 6.24183C2.82972 6.40047 2.82972 6.65762 2.98836 6.81627L4.9991 8.8272C5.15774 8.98564 5.41489 8.98564 5.57374 8.8272C5.59202 8.80892 5.60767 8.789 5.62189 8.7683L9.66895 4.69624C9.82739 4.5376 9.82739 4.28044 9.66895 4.12161C9.51011 3.96297 9.25295 3.96297 9.09411 4.12161Z",
    fill: "#68686D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_259_2251"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentApprovementCheck);
export default __webpack_public_path__ + "static/media/studentApprovementCheck.fdca59072171665243509a84b4b3fbdf.svg";
export { ForwardRef as ReactComponent };